/* Product cards: colour dots on one line. Dots that don't fit are hidden and a "+N" chip shows how many more. */
(function () {
  var SELECTOR = '.modern-card-wrapper .grid-product__colors';

  function fit(row) {
    var dots = Array.prototype.filter.call(row.children, function (el) {
      return !el.classList.contains('lb-sw-more');
    });
    var more = row.querySelector('.lb-sw-more');
    dots.forEach(function (d) { d.classList.remove('lb-sw-hidden'); });
    if (more) more.remove();
    if (!dots.length || row.clientWidth === 0) return;
    if (row.scrollWidth <= row.clientWidth + 1) return;

    more = document.createElement('span');
    more.className = 'lb-sw-more';
    more.setAttribute('aria-hidden', 'true');
    row.appendChild(more);

    var hidden = 0;
    for (var i = dots.length - 1; i > 0; i--) {
      dots[i].classList.add('lb-sw-hidden');
      hidden++;
      more.textContent = '+' + hidden;
      if (row.scrollWidth <= row.clientWidth + 1) break;
    }
    var card = row.closest('.grid-product, .modern-card-wrapper');
    var link = card && card.querySelector('a.grid-product__link');
    if (link) more.title = hidden + ' more colours';
  }

  function fitAll(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(fit);
  }

  var timer;
  function later() {
    clearTimeout(timer);
    timer = setTimeout(function () { fitAll(); }, 120);
  }

  function start() {
    fitAll();
    window.addEventListener('resize', later);
    window.addEventListener('load', later);
    // cards added later (sliders, filters, "load more")
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var r = records[i];
        for (var j = 0; j < r.addedNodes.length; j++) {
          var n = r.addedNodes[j];
          if (n.nodeType === 1 && !n.classList.contains('lb-sw-more') && (n.matches(SELECTOR) || n.querySelector(SELECTOR))) {
            later();
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
